document.addEventListener('DOMContentLoaded', function() {
  const triggers = document.querySelectorAll('.open-modal');

  // トリガーすべてにイベント付与
  triggers.forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      if (trigger.tagName === 'A') e.preventDefault();

      const modalId = trigger.dataset.modal;
      const modal = document.getElementById(modalId);

      if (!modal) return;
      modal.classList.add('active');

      // モバイルのみスクロール停止
      if (window.innerWidth < 768) {
        document.body.style.overflow = 'hidden';
      }

      // 閉じる処理
      const closeBtn = modal.querySelector('.modal-close');
      if (closeBtn) {
        closeBtn.onclick = () => closeModal(modal);
      }

      // overlayクリックで閉じる
      modal.onclick = (e) => {
        if (e.target === modal) closeModal(modal);
      };

      // ESCで閉じる
      document.onkeydown = (e) => {
        if (e.key === 'Escape') closeModal(modal);
      };
    });
  });

  // 共通の閉じる関数
  function closeModal(modal) {
    modal.classList.remove('active');

    if (window.innerWidth < 768) {
      setTimeout(() => {
        document.body.style.overflow = '';
      }, 300);
    }
  }
});
